import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: {
          "titulo": "🥊 Guanteo: Golpeá con Memoria. Ganá con Estrategia.",
          "descripcion":  `<strong>Un duelo cara a cara donde cada decisión puede cambiar el rumbo del combate.</strong><br /><br />
                  En <strong>Guanteo</strong>, dos jugadores se enfrentan en un ring de 16 cartas dispuestas al azar. Cada uno comienza con el control de 8, pero solo quien logre quedarse con <strong>12 cartas al final de su turno</strong> será el campeón.<br /><br />
                  🎯 <strong>¿El desafío?</strong><br />
                  Tus cartas (y las del rival) están boca abajo toda la partida. Para ganar, vas a tener que <strong>memorizar, anticipar y golpear con precisión</strong>. Si errás... podrías terminar golpeándote a vos mismo.<br /><br />
                  🧠 <strong>Memoria + Estrategia</strong><br />
                  Cada jugador tiene su propio mazo (rojo o azul) y deberá usar sus cartas con inteligencia para atacar, abrirse camino en el tablero y robar nuevas cartas. Pero cada acción mal ejecutada puede ser un paso hacia la derrota.<br /><br />
                  🔁 <strong>Cada turno cuenta</strong><br />
                  Atacar al rival te da ventajas: más cartas, más información, más chances de recuperar el control del tablero. Pero también podés intercambiar cartas, planear tu próximo movimiento o ejecutar combos... <strong>si recordás qué hay bajo cada carta.</strong><br /><br />
                  ⚠️ <strong>No es solo golpear. Es saber cuándo, cómo y dónde hacerlo.</strong>`,
                  "manual": "¿Querés leer el manual?",
                  "manualbtn": "Ver Manual",
                  "manual_pdf": "/Reglamento Guanteo.pdf",
                  "titulovideo": "Guanteo en Acción: Como se juega",
                  "descvideo": "Te Contamos Como Jugar",
                   "callactiontitulo": "¿Listo para subir al ring? ¡Conseguí tu Guanteo hoy!",
                   "callactionbtn1": "Ir a la Tienda",
                   "callactionbtn2": "Venta Mayorista",
                   "preguntasfrecuentestitulo": "Preguntas Frecuentes",

                   "faq_items": [
                      {
                        "question": "¿Para cuántas personas es Guanteo?",
                        "answer": "Guanteo está diseñado exclusivamente para 2 jugadores, ideal para partidas intensas y dinámicas."
                      },
                       {
                        "question": "¿Cuánto dura una partida?",
                        "answer": "En promedio, una partida dura entre 25 y 45 minutos, dependiendo de la memoria (¡y estrategia!) de los jugadores."
                      },
                      {
                        "question": "¿Es apto para todas las edades?",
                        "answer": "El juego está recomendado para adultos mayores de 14 años. No tiene contenido inapropiado, pero requiere memoria y táctica."
                      },
                      {
                        "question": "¿Qué incluye la caja del juego?",
                        "answer": "El juego incluye 110 cartas: 2 Mazos (Rojo y Azul) idénticos de 45, 2 de ayuda por jugador, 16 de tablero y el reglamento. ¡Todo lo que necesitás para jugar en cualquier lado!"
                      },
                       {
                        "question": "¿Donde puedo conseguirlo?",
                        "answer": "Podés comprar Guanteo en nuestra tienda online."
                      },
                      
                    ],

                    "frasefooter": "Un juego de Memoria y Estrategia",
                    "copiright": "Todos los derechos reservados.",
                     "modalmayoristatitutlo": "Venta Mayorista",

                     
                     // En tu i18n.js
"wholesale": {
  "greeting": "¡Hola! ¿Cómo estás?",
  "question": "¿Querés vender <em>Guanteo</em> en tu tienda?",
  "register": "Registrate en nuestra tienda mayorista y hacé tu pedido!",
  "whatsapp": "Para que puedas comenzar a operar tenemos que aprobar tu registro, para acelerar el proceso escribinos por Whatsapp."
},
       
 "modalmayoristabtn": "Ir a la Tienda Mayorista",
            

                   
                
        }
      },
      en: {
        translation: {
          "titulo": "🥊 Guanteo: Strike with memory. Win with strategy.",
          "descripcion": `<strong>A head-to-head duel where every decision can turn the tide of battle.</strong><br /><br />
In <strong>Guanteo</strong>, two players face off in a ring of 16 randomly arranged cards. Each player starts in control of 8, but only the one who manages to hold <strong>12 cards at the end of their turn</strong> will be the champion.<br /><br />
🎯 <strong>The challenge?</strong><br />
Your cards (and your opponent's) stay face down throughout the game. To win, you'll need to <strong>memorize, anticipate, and strike with precision</strong>. If you miss... you could end up hitting yourself.<br /><br />
🧠 <strong>Memory + Strategy</strong><br />
Each player has their own deck (red or blue) and must use their cards intelligently to attack, clear a path on the board, and steal new cards. But every misplayed move can be a step toward defeat.<br /><br />
🔁 <strong>Every turn counts</strong><br />
Attacking your rival gives you advantages: more cards, more information, and more chances to regain control of the board. But you can also swap cards, plan your next move, or pull off combos... <strong>if you remember what's under each card.</strong><br /><br />
⚠️ <strong>It’s not just about striking. It’s about knowing when, how, and where to do it.</strong>`,
          "manual": "Want to check out the rulebook?",
          "manualbtn": "View Rules",
           "manual_pdf": "/Reglamento Guanteo Eng.pdf",
          "titulovideo": "Guanteo in Action: How to play",
          "descvideo": "Here’s How to Play",
          "callactiontitulo": "Ready to step into the ring? Get your Guanteo today!",
          "callactionbtn1": "Shop (Argentina Only)",
          "callactionbtn2": "For Retailers",
          "preguntasfrecuentestitulo": "Frequently Asked Questions",

          "faq_items": [
          {
            "question": "How many players is Guanteo for?",
            "answer": "Guanteo is designed exclusively for 2 players, ideal for intense and dynamic matches."
          },
          {
            "question": "How long does a game last?",
            "answer": "On average, a game lasts between 25 and 45 minutes, depending on the players' memory (and strategy!)."
          },
          {
            "question": "Is it suitable for all ages?",
            "answer": "The game is recommended for ages 14 and up. It has no inappropriate content, but it requires memory and tactics."
          },
          {
            "question": "What does the game box include?",
            "answer": "The game includes 110 cards: 2 identical 45-card decks (Red and Blue), 2 player aids, 16 board cards, and the rulebook. Everything you need to play anywhere!"
          },
          {
            "question": "Where can I get it?",
            "answer": "You can buy Guanteo in our online store."
          }
        ],

        "frasefooter": "A Memory and Strategy Game",
        "copiright": "All rights reserved",
        "modalmayoristatitutlo": "Become a Retailer",

      
"wholesale": {
  "greeting": "Hi! How are you?",
  "question": "Do you want to sell <em>Guanteo</em> in your store?",
  "register": "Register in our wholesale store and place your order!",
  "whatsapp": "To start operating, we need to approve your registration. To speed up the process, write to us on WhatsApp."
},

 "modalmayoristabtn": "Wholesale (Argentina Only)",


        }
      }
    },
    lng: "es", // Idioma por defecto
    fallbackLng: "es",
    interpolation: { escapeValue: false }
  });

export default i18n;